const { __, _x, _n, _nx } = wp.i18n;

/**
 * Implements page rating.
 */
var Rating = ( function() {
	var C = function(){ return constructor.apply(this,arguments); };
	var p = C.prototype;

	function constructor( element ) {
		var self = this;
		this.element = element;
		this.commentId = element.dataset.commentId;

		var ratingLink = element.querySelector( '.comment-rating__helpful' );
		if ( ratingLink ) {
			ratingLink.addEventListener(
				'click', this.handleRating.bind( this, true ) );
		}

		var undoLink = element.querySelector( '.comment-rating__undo' );
		if ( undoLink ) {
			undoLink.addEventListener(
				'click', this.handleRating.bind( this, null ) );
		}
	};

	// Handle ratings
	p.handleRating = function( isHelpful, event ) {
		event.preventDefault();
		var self = this;

		var isUndo = isHelpful === null;

		this.oldContent = this.element.innerHTML;
		this.element.innerHTML = this.element.dataset.loadingText;

		var jqxhr = jQuery.ajax( {
			url: wpApiSettings.root + 'iportal/v1/comment_ratings/'
				+ this.commentId,
			method: isUndo ? 'DELETE' : 'PUT',
			data: isUndo ? {} : {
				'is_helpful': isHelpful
			},
			beforeSend: function( xhr ) {
				xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
			},
		} ).done( function( response ) {
			self.element.innerHTML = self.element.dataset.savedText;
		} ).fail( function() {
			self.element.innerHTML = __( 'Could not save rating, please try again later', 'iportal-theme' );
		} );
	};

	return C;
} )();

export default Rating;